import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import SessionLogoutEventResponse from '../../../users/base/i-service/models/responses/SessionLogoutEventResponse';

/**
 * * Севрис для сохранения сотрудников
 */
export default class PerformersSaveService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	/**
	 * * Ивент логов публикации.
	 */
	SessionLogoutEventEvent = new Events<WsResponseModelT<SessionLogoutEventResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('PerformersSaveService', 'SessionLogoutEvent', 'Main', (res: WsResponseModelT<SessionLogoutEventResponse>) => {
			self.SessionLogoutEventEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	
}